import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=f71b61ec&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=f71b61ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71b61ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f71b61ec')) {
      api.createRecord('f71b61ec', component.options)
    } else {
      api.reload('f71b61ec', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=f71b61ec&scoped=true&", function () {
      api.rerender('f71b61ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24d3Wi1Kovvmu/JS/comp/PopupBox.vue"
export default component.exports